import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { ReportEquipment, EquipmentClassificationIcon, EquipmentClassification } from '@app-model/vehicle';
import { EvaluationVehicle } from '@app-model/evaluation';
import { DecimalPipe } from '@angular/common';
import { NgxGalleryImage } from 'ngx-gallery-images-video';
import { OpenService } from '@app-services/open.service';

@Component({
  selector: 'app-evaluation-list-report',
  templateUrl: './evaluation-list-report.component.html',
  styleUrls: ['./evaluation-list-report.component.scss']
})
export class EvaluationListReportComponent implements OnInit {
  @Input() reportItems;
  @Input() hideTitle = false;
  @Input() audio;
  @Input() isEvaluation = false;
  showMobile = false || this.hideTitle;
  oldLayout = false;
  audioReport: HTMLAudioElement;
  itemKeys = [];
  decimalPipe: DecimalPipe;
  galleryImages: NgxGalleryImage[] = [];
  galleryOptions = [
    {
      image: false,
      width: "90%",
      height: "40px",
      imageAnimation: "slide",
      thumbnailsColumns: 2,
      previewCloseOnClick: true,
      previewCloseOnEsc: true,
      thumbnailsRemainingCount: true,
      thumbnailsMargin: 0,
      imageArrowsAutoHide: true,
      thumbnailsArrowsAutoHide: false,
      thumbnailsRows: 1,
      imageSwipe: true,
      previewZoom: true,
      previewRotate: true,
      imageInfinityMove: true,
      thumbnailsSwipe: true,
      previewInfinityMove: true,
      imageDescription: false,
      startIndex: 10
    },
  ];


  constructor(private openService: OpenService, private ref: ChangeDetectorRef) { }

  ngOnInit() {
    if (this.reportItems) {
      this.itemKeys = Object.keys(this.reportItems).filter(report => this.displayEquip(report));
    }
    this.decimalPipe = new DecimalPipe('pt-BR');
    // this.checkingIfTheItemHasMedia();
  }

  getReportEquipLabel(equip: string): string {
    return ReportEquipment[equip];
  }

  getClassification(report) {
    const r = this.reportItems[report];
    return EquipmentClassification[r.classification];
  }

  displayEquip(report): boolean {
    const classification = this.getClassification(report);
    return classification !== EquipmentClassification.NON_EXISTENT;
  }

  getClassificationIcon(report): string {
    const r = this.reportItems[report];
    return EquipmentClassificationIcon[r.classification];
  }

  getDescriptionReport(report): string {
    const r = this.reportItems[report];
    return r.description ? (r.description.length > 70 ? r.description.slice(0, 70) + '...' : r.description) : '';
  }

  getTooltipDescriptionReport(report): string{
    const r = this.reportItems[report];
    return r.description || '';
  }

  getValueReport(report): string {
    const r = this.reportItems[report];
    return r.fixingCost;
  }

  getTooltipText(report): string {
    let result = '';
    if (this.getDescriptionReport(report)) {
      result += this.getDescriptionReport(report);
    }
    if (this.getValueReport(report)) {
      if (result.length > 0) {
        result += '\n';
      }
      result += 'Reparo: R$ ' + this.decimalPipe.transform(this.getValueReport(report), '1.2-2');
    }

    return result.length > 0 ? result : undefined;
  }

  getGalleryImages(report): NgxGalleryImage[] {
    const r = this.reportItems[report];
    let galleryImages = [];
    if (Array.isArray(r.photosAndVideosUrls)) {
      galleryImages = r.photosAndVideosUrls.map((i) => {
        const img = i;
        const thumb = this.getThumbUrl(img);
        return {
          small: thumb,
          medium: img,
          big: img
        };
      });
    }
    return galleryImages;
  }

  getThumbUrl(imgUrl: string): string {
    if (imgUrl.endsWith("mp4")) {
      return imgUrl;
    }
    return this.openService.getThumbImageUrl(imgUrl);
  }

  hasAudio(report): boolean {
    const r = this.reportItems[report];
    return r !== undefined && r.audio !== undefined && r.audio.duration > 0;
  }

  playAudio(report): void {
    const r = this.reportItems[report];

    if (r.audio === undefined) {
      return;
    }

    if (this.audioReport && !this.audioReport.paused) {
      this.audioReport.pause();
    } else {
      this.audioReport = new Audio(r.audio.url);
      this.audioReport.play();
    }

    this.ref.detectChanges();
    this.audioReport.addEventListener("endend", () => { this.ref.detectChanges() })
  }

  thisAudioIsPlaying(report): boolean {
    const r = this.reportItems[report];
    if (this.audioReport === undefined) {
      return false;
    }
    return r.audio.url === this.audioReport.src && !this.audioReport.paused;
  }

  checkingIfTheItemHasMedia() {
    if (this.reportItems !== undefined) {
      let equipments = Object.keys(this.reportItems);
      for (let e of equipments) {
        let reportItem = this.reportItems[e];
        if (reportItem.photosAndVideosUrls != undefined && reportItem.photosAndVideosUrls.length > 0) {
          this.oldLayout = false;
          break;
        }
        if (reportItem.audio != undefined && reportItem.audio.duration > 0) {
          this.oldLayout = false;
          break;
        }
      }
    }
  }
}
